import React from 'react';
import HistoryIcon from '@mui/icons-material/History';

const HistorySection = () => {
  return (
    <div className="py-12 md:py-20 bg-gray-50 relative rounded-2xl mb-8 md:mb-12 overflow-hidden">
      {/* Subtle Pattern Background */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCI+CjxyZWN0IHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCIgZmlsbD0iI2ZmZmZmZiI+PC9yZWN0Pgo8Y2lyY2xlIGN4PSI1IiBjeT0iNSIgcj0iMiIgZmlsbD0iI2UyZThmMCI+PC9jaXJjbGU+Cjwvc3ZnPg==')] opacity-50"></div>
      
      {/* Decorative Elements */}
      <div className="absolute right-0 bottom-0 w-64 h-64 bg-[#0488AF] opacity-5 rounded-full"></div>
      <div className="absolute left-0 top-20 w-40 h-40 bg-[#DC3465] opacity-5 rounded-full"></div>

      <div className="max-w-6xl mx-auto px-4 relative z-10">
        {/* Section Title with Enhanced Design */}
        <div className="mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#09274A] inline-flex items-center gap-3 relative">
            <span className="flex items-center justify-center w-14 h-14 rounded-full bg-[#0488AF10] text-[#0488AF]">
              <HistoryIcon fontSize="large" />
            </span>
            Nuestra Historia
            <span className="absolute -bottom-3 left-0 w-24 h-1 bg-gradient-to-r from-[#0488AF] to-[#DC3465] rounded-md"></span>
          </h2>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Images with Enhanced Design */}
          <div className="relative h-[350px] md:h-[400px]">
            {/* Image 1 */}
            <img 
              src="https://res.cloudinary.com/duz01skao/image/upload/v1746470944/public/n7rrtx5f0ducqe3w75vx.jpg"
              alt="Reunión de socios CIDERE"
              className="absolute top-0 left-0 w-[70%] h-[60%] object-cover rounded-2xl border-4 border-white shadow-lg transition-all duration-500 ease-in-out hover:translate-y-[-8px] hover:rotate-2 hover:shadow-xl z-10"
              loading="lazy"
            />
            
            {/* Image 2 */}
            <img 
              src="https://res.cloudinary.com/dfj2ny7qp/image/upload/v1744214127/Public/fvbm11avmh9moul6hyzq.jpg"
              alt="Evento corporativo CIDERE"
              className="absolute bottom-0 right-0 w-[60%] h-[50%] object-cover rounded-2xl border-4 border-white shadow-lg transition-all duration-500 ease-in-out hover:translate-y-[-8px] hover:-rotate-2 hover:shadow-xl z-5"
              loading="lazy"
            />
            
            
            {/* Decorative Circle */}
            <div className="absolute bottom-[-20px] left-[-20px] w-[150px] h-[150px] rounded-full bg-[#DC346510] z-0"></div>
          </div>

          {/* Text Content */}
          <div className="rounded-2xl overflow-hidden transition-all duration-300 ease-in-out hover:translate-y-[-5px] bg-white h-full shadow-lg">
            <div className="p-6 md:p-8 h-full">
              <p className="text-lg leading-relaxed text-gray-700 mb-6 relative pl-6 before:content-[''] before:absolute before:left-0 before:top-0 before:h-full before:w-1 before:bg-[#0488AF] before:rounded-md">
                RDS es un espacio digital creado para 
                <span className="text-[#09274A] font-bold italic"> fortalecer la vinculación, colaboración y crecimiento entre los socios de CIDERE</span>. 
                Nace en 2024 en alianza con la Escuela de Ingeniería de la Universidad Católica del Norte, sede Coquimbo, bajo el modelo <span className='italic'>Captsone Project</span>.
              </p>

              <p className="text-lg leading-relaxed text-gray-700 mb-6 pl-6">
                Su propósito es facilitar la interacción entre socios, impulsar el intercambio de información y abrir nuevas oportunidades de negocio, todo dentro de un entorno colaborativo y dinámico. RDS busca ser una herramienta de alto impacto, en constante evolución, que refleje las necesidades y desafíos del ecosistema empresarial, exclusiva para las organizaciones socias de CIDERE. 
              </p>

              <p className="text-lg leading-relaxed text-gray-700 pl-6">
                RDS refleja el compromiso de CIDERE con el desarrollo regional, promoviendo la colaboración entre organizaciones como motor de crecimiento. 
                <span className="text-[#09274A] font-bold italic"> RDS no es solo una herramienta digital, es una iniciativa construida por y para los socios: su participación activa es clave para dar vida a esta red, enriquecerla y proyectarla hacia el futuro.</span>
              </p>
            </div>
  
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(HistorySection);